import { Alert, Stack, Typography } from '@mui/joy';
import { WarningCircle } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Color, Level, Size, Variant } from 'theme/enums';

const ICON_SIZE = 24;

interface IProps {
  title: string;
  message: string;
  onRetry: () => void;
}

export const ReportError = ({ title, message, onRetry }: IProps) => {
  const { t } = useTranslation();

  return (
    <Alert
      startDecorator={<WarningCircle size={ICON_SIZE} />}
      variant={Variant.SOFT}
      color={Color.DANGER}
      size={Size.LG}
      endDecorator={
        <Button
          variant={Variant.OUTLINED}
          color={Color.DANGER}
          size={Size.SM}
          onClick={onRetry}
          text={t('buttonLabelRetry')}
        />
      }
      sx={{ alignItems: 'center', width: '100%' }}
    >
      <Stack>
        <Typography level={Level.TITLE_SM}>{title}</Typography>

        <Typography level={Level.BODY_SM}>{message}</Typography>
      </Stack>
    </Alert>
  );
};
